<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span 
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>
    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <div class="grid grid-cols-9 gap-3">
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Transaction ID:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="transactionId" type="text" placeholder="Transaction ID">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-141-px font-semibold">Phone Number:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="phoneNumber" type="text" placeholder="Phone Number">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Product Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="productName" type="text" placeholder="Product Name">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-106-px font-semibold">First Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="firstName" type="text" placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-141-px font-semibold">Middle Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="middleName" type="text" placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-106-px font-semibold">Last Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="lastName" type="text" placeholder="Last Name">
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-5 mt-3">
                <div class="col-span-2"></div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date From:" [parentForm]="form" controlName="dateFrom"></app-date-input>
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date To:" [parentForm]="form" controlName="dateTo"></app-date-input>
                    </div>
                </div>
                <div class="col-span-2"></div>
            </div>
            <div class="grid grid-cols-12 gap-5 mt-3">
                <div class="col-span-2"></div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <div class="flex items-center">
                            <span class="text-xs w-60-px font-semibold">Category:</span>
                            <div #t2="matMenuTrigger" #select2 [matMenuTriggerFor]="category_select" class="rounded-md py-3 pl-0 minw-200-px flex justify-between items-center h-30-px cursor-pointer">
                                <span *ngIf="!categoryType_text" class="barlow text-black text-xs italic font-lg p-5 italic">All</span>
                                <span *ngIf="categoryType_text" class="barlow text-black text-xs italic font-lg p-5">{{categoryType_text}}</span>
                                <span class="material-icons violet-text">arrow_drop_down</span>
                            </div>
                            <mat-menu class="w-full sports-menu" #category_select="matMenu">
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic">All</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType(' Food and Beverage','2')">Food and Beverage</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType(' Prepaid Load','3')">Prepaid Load</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType('Shopping','4')">Shopping</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType('Entertainment','5')">Entertainment</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType('Travel','6')">Travel</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType('Health','7')">Health</button>
                                <button mat-menu-item class="tracking-wide focus:outline-none text-xs italic" (click)="setCategoryType(' Gaming Pins','8')">Gaming Pins</button>
                            </mat-menu>
                        </div>
                    </div>
                </div>
                <div class="col-span-2"></div>
            </div>
        </form>
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button (click)="submit()" class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <div *ngIf="showTable">
        <div *ngIf="submitted">
            <app-table-controls
                [currentLimit]="activeLimit?.size ?? 10"
                [showLimitControl]="true"
                [showSearchControl]="true"
                (limitChangeEvent)="activeLimit?.onLimitChange($event)"
                (searchKeyupEvent)="activeSearch?.onSearchKeyup($event)"
                (keydownEvent)="keyDownFunction($event)"
            ></app-table-controls>

            <div class="bg-light-orange w-full maxh-550-px px-3 overflow-x-auto w-table">
                <div class="data-table4 mt-3 barlow text-xs" style="font-size: 10px;">
                    <table class="w-full">
                        <thead>
                            <tr>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    TRANSACTION ID
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('transactionId', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    DATE / TIME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('dateTime', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    NAME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('firstName', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    PHONE NUMBER
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('phoneNumber', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    PRODUCT NAME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('productName', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    PRODUCT CODE
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('productCode', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    RECIPIENT NUMBER EMAIL
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('recipientNumberEmail', sort_type)">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    AMOUNT
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('amount', sort_type)">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="focus:outline-none" *ngFor="let item of activeList">
                                <td>{{ item.transactionId ?? '-' }}</td>
                                <td>{{ item.dateTime ?? '-' | date:' yyyy-dd-MM  hh:mm:ss' }}</td>
                                <td>{{ item.name ?? '-' | titlecase }}</td>
                                <td>{{ item.phoneNumber ?? '-' }}</td>
                                <td>{{ item.productName ?? '-' }}</td>
                                <td>{{ item.productCode ?? '-' }}</td>
                                <td>{{ item.recipientNumberEmail ?? '-' }}</td>
                                <td>{{ item.amount ?? '-' }}</td>
                            </tr>

                            <!-- Loading state -->
                            <tr *ngIf="isLoadingData">
                                <td colspan="8" class="text-center py-4 text-gray-500" style="border-bottom: 1px solid rgba(0,0,0,0.1);">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <span class="italic text-xs">Loading data, please wait...</span>
                                    </div>
                                </td>
                            </tr>

                            <!-- Empty state (only shown after loading completes) -->
                            <tr *ngIf="!isLoadingData && (!activeList || activeList.length === 0)">
                                <td colspan="8" class="text-center py-4 text-gray-500" style="border-bottom: 1px solid rgba(0,0,0,0.1);">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <img src="../../../../assets/images/icon/no-data.webp"
                                            alt="No Data"
                                            style="height: 48px; opacity: 0.4;"
                                            onerror="this.style.display='none'">
                                        <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                                        <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <app-pagination
                backgroundColor="bg-light-orange"
                [showTotalEntries]="true"
                [currentPage]="activePage?.current ?? 1"
                [totalPages]="activePage?.total ?? 1"
                [pageSize]="activeLimit?.size ?? 10"
                [totalItems]="activeLimit?.total ?? 0"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                (pageChange)="setPage($event)"
            ></app-pagination>
        </div>
    </div>
</div>
<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>